import { render, staticRenderFns } from "./SecurityScore.vue?vue&type=template&id=16720cec&scoped=true&"
import script from "./SecurityScore.vue?vue&type=script&lang=js&"
export * from "./SecurityScore.vue?vue&type=script&lang=js&"
import style0 from "./SecurityScore.vue?vue&type=style&index=0&id=16720cec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16720cec",
  null
  
)

export default component.exports